import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { InformixCopySource } from 'app/model/pipeline/copysource/informix.copysource';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { ValueAdapter } from '../../value.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(InformixCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class InformixCopySourceAdapter extends CopySourceAdapter<InformixCopySource, Model.InformixSource> {
    protected override async _toResource(copySource: InformixCopySource): Promise<Model.InformixSource> {
        const result: Model.InformixSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(InformixCopySource).name
        );
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, InformixCopySource.READER_QUERY);
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.InformixSource,
        copyActivity: CopyActivity
    ): Promise<InformixCopySource> {
        return this._toTabularModel(resource, copyActivity, InformixCopySource.MODEL);
    }
}
